import React from "react"
import LocalIntro from "../content/local_intro"
import BestRadios from "../content/best_radios"
import AreaList from "../areas/AreaList"
import TypesOfRadios from "../content/types_of_radios"
import CheapRadios from "../content/cheap_radios"
import CTA from "../content/cta"
import Rentals from "../content/rentals"
import MostPopular from "../content/most_popular"


function County({ data }) {
  return (
    <>
      <LocalIntro data={data}/>
      <AreaList areaList={data.citiesInCounty} areaName={data.area_name} areaCopy={`Cities We Serve In`} />
      <BestRadios data={data}/>
      <TypesOfRadios data={data}/>
      <Rentals data={data} />
      <MostPopular data={data} />
      <CheapRadios data={data}/>
      <AreaList areaList={data.zipsInCounty} areaName={data.area_name} areaCopy={`Service Areas In`} />
      <AreaList areaList={data.countiesNearby} areaName={data.area_name} areaCopy={`Counties We Serve Near`} />
      <AreaList areaList={data.citiesInState} areaName={data.state} areaCopy={`Other Service In`} />
      <CTA />
    </>
  )
}

export default County
